import React from 'react';
import PropTypes from 'prop-types';
import GenericTextareaEdit from '../GenericTextareaEdit';
import { crosstabViewTextEllipsis, shortLabelText } from '../../../util/CrosstabUtils';

function Label( props ) {
  return (
    <span className="fullLabel">
      <GenericTextareaEdit
        validate={text => text.length > 0}
        activeClassName="editing"
        text={props.toggleLabel || props.label.toLowerCase() === 'total' ||
          props.label.length < 25 ? crosstabViewTextEllipsis(props.gridType, props.label) : shortLabelText(props.label)}
        fullText={props.label}
        toggleLabel={props.toggleLabel}
        paramName="title"
        originalLabel={props.label}
        editEnabled={props.editEnabled}
        isLabelUpdated={props.isLabelUpdated}
        minRows={props.minRows}
        maxRows={props.maxRows}
        minHeight={props.minHeight}
        maxHeight={props.maxHeight}
        cols={props.cols}
        style={{ ...props.style }}
        resetSelectedIndex={props.resetSelectedIndex}
        change={updatedObjectProps => {
          if (
            props.gridType === 'ColumnsDataGrid' ||
            props.gridType === 'RowsDataGrid'
          ) {
            props.updateCrosstabGridTitleHeader({
              originalTitle: props.label.trim(),
              updatedTitle: updatedObjectProps.title.trim(),
              gridCategory: props.gridType,
              index: props.index,
            });
          }
          const latestUpdatedProps = {
            ...updatedObjectProps,
            originalTitle: updatedObjectProps.title,
          };
          props.updateGridData(latestUpdatedProps, props.gridType, props.index);
        }
        }
        showFootNoteIcon={props.showFootNoteIcon}
        crosstabFootNotes={props.crosstabFootNotes}
        index={props.index}
      />
    </span>
    );
};

Label.propTypes = {
  label: PropTypes.string,
  toggleLabel: PropTypes.bool,
  editEnabled: PropTypes.bool,
  updateGridData: PropTypes.func,
  updateCrosstabGridTitleHeader: PropTypes.func,
  gridType: PropTypes.string,
  index: PropTypes.number,
  isLabelUpdated: PropTypes.bool,
  cols: PropTypes.number,
  rows: PropTypes.number,
  showFootNoteIcon: PropTypes.instanceOf(Array),
  crosstabFootNotes: PropTypes.shape({}),
};

export default Label;
